import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DividerModule } from './../../divider/divider.module';
import { HeadingModule } from './../../heading/heading.module';
import { DropdownHeaderComponent } from './dropdown-header.component';

@NgModule({
  declarations: [DropdownHeaderComponent],
  exports: [DropdownHeaderComponent],
  imports: [CommonModule, HeadingModule, DividerModule],
})
export class DropdownHeaderModule {}
export { DropdownHeaderComponent } from './dropdown-header.component';
